import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--form-value-switch"
export default class extends Controller {
  connect() {}

  toTrue(e) {
    e.preventDefault();
    this.element.value = "true";
  }

  toFalse(e) {
    e.preventDefault();
    this.element.value = "false";
  }
}
